import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var FlipIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M4 11c0-.226.099-.517.429-.865.335-.354.868-.719 1.603-1.047C7.502 8.433 9.606 8 12 8s4.498.433 5.968 1.088c.735.328 1.268.693 1.603 1.047.33.348.429.64.429.865 0 .236-.111.541-.515.926-.409.39-1.044.784-1.891 1.16a1 1 0 10.812 1.828c.953-.424 1.818-.93 2.459-1.54C21.51 12.758 22 11.964 22 11c0-.874-.401-1.633-.977-2.241-.571-.603-1.351-1.1-2.24-1.497C17 6.467 14.605 6 12 6c-2.606 0-5.001.467-6.782 1.262-.89.397-1.67.894-2.24 1.497C2.4 9.367 2 10.126 2 11c0 .874.401 1.633.977 2.241.571.603 1.351 1.1 2.24 1.497 1.71.763 3.986 1.224 6.471 1.26l-.295.295a1 1 0 101.414 1.414l1.8-1.8.115-.115.072-.145c.241-.481.241-1.013 0-1.494l-.072-.145-.115-.115-1.8-1.8a1 1 0 00-1.414 1.414l.492.493c-2.346-.014-4.407-.443-5.853-1.088-.735-.329-1.268-.693-1.603-1.047C4.099 11.517 4 11.225 4 11z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
FlipIcon.isCarinaIcon = true;
export default FlipIcon;
